import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Create and export a single MSAL instance to be used across the app
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize the MSAL instance - this must be called before using the instance
// MSAL will handle this automatically when needed, but we can also initialize eagerly
msalInstance.initialize();
